import styled from "@emotion/styled";

export const UploadImageWrapper = styled.div`
  position: relative;
  background: #e8f0fe;
  border: 1px dashed #97bff6;
  border-radius: 12px;
  height: 254px;
  width: 100%;
  height: 254px;
  color: #003b6f;
  gap: 30px;

  @media (min-width: 428px) {
    width: 398px;
    height: 254px;
  }

  @media (min-width: 744px) {
    height: 330px;
    width: 550px;
  }

  @media (min-width: 1440px) {
    width: 550px;
    height: 350px;
  }
`;

export const UploadButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: 300;
  font-size: 24px;
  gap: 30px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 1;
`;

export const UploadButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffbf3a;
  border-radius: 49px;
  font-weight: 400;
  font-size: 18px;
  height: 45px;
  width: 153px;
  color: #ffffff;
  cursor: pointer;
`;
export const PreviewImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  gap: 3px;
  overflow: hidden;

  @media (min-width: 1440px) {
    gap: 4px;
  }
`;
export const PreviewImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const PreviewImageColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 4.24px;
`;
export const PreviewImageHalf = styled.div`
  width: 100%;
  height: 50%;
  position: relative;
`;
export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const MoreImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  color: #ffff;
  font-size: 48px;
`;
